import { type FC } from 'react';
import { NoDataMessage } from '@/components/NoDataCard/NoDataCard';
import styles from './RecentSessionsPanel.module.scss';

/**
 * Fixed-width panel showing recent agent sessions.
 * Currently renders an empty state — real session data is a future ticket.
 */
const RecentSessionsPanel: FC = () => {
  return (
    <div
      className={styles.panel}
      data-test-component="RecentSessionsPanel"
      data-test-element="container"
      data-testid="recent-sessions-panel"
    >
      <div className={styles.panelHeader} data-test-element="header">
        <span className={styles.headerTitle} data-test-element="title">
          Recent
        </span>
        <span className={styles.headerLink} data-test-element="link">
          View all sessions
        </span>
      </div>
      <div className={styles.panelBody} data-test-element="body">
        <NoDataMessage title="No recent sessions" text="Agent sessions you run will appear here." dark />
      </div>
    </div>
  );
};

export default RecentSessionsPanel;
